"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var React = require("react");
var icon_types_1 = require("../../types/icon.types");
var FontAwesome_1 = require("../FontAwesome");
var IconWrapper_1 = require("../IconWrapper");
var Input_1 = require("../Input");
var InputGroup_1 = require("../InputGroup");
exports.SearchInput = function (props) {
    var _a;
    var getIcon = function (showLoader, value) {
        if (showLoader) {
            return icon_types_1.Icon.Loading;
        }
        if (value) {
            return icon_types_1.Icon.Clear;
        }
        return icon_types_1.Icon.Search;
    };
    var icon = getIcon(props.showLoader, props.value);
    return (React.createElement(InputGroup_1.InputGroup, { className: props.className },
        React.createElement(Input_1.Input, { onChange: props.onChange, placeholder: props.placeholder, value: props.value }),
        React.createElement(InputGroup_1.InputGroup.Addon, { watermark: true, onClick: props.onClear },
            React.createElement(IconWrapper_1.IconWrapper, null,
                React.createElement(FontAwesome_1.FontAwesome, { className: classNames((_a = {},
                        _a[props.className + "__clear-icon"] = icon === icon_types_1.Icon.Clear,
                        _a)), name: icon, spin: props.showLoader })))));
};
exports.SearchInput.displayName = 'SearchInput';
//# sourceMappingURL=SearchInput.js.map